import React from "react";
import SmartRender from "containers/SmartRender";

export const DirectPaymentLinkExpiredPageHOC = Component =>
  function Comp(props) {
    return <Component {...props} />;
  };

export default DirectPaymentLinkExpiredPageHOC(SmartRender);
